export type ProgressionSnapshot = {
  roundNumber: number;
  score: number;
};

export const NEGATIVE_ENABLED_STARTING_ROUND = 6;
export const NEGATIVE_ENABLED_STARTING_SCORE = 6_000;
export const INCREMENT_ENABLED_STARTING_ROUND = 8;
export const INCREMENT_ENABLED_STARTING_SCORE = 16_000;
export const REFILL_ENABLED_STARTING_ROUND = 10;
export const REFILL_ENABLED_STARTING_SCORE = 30_000;
export const EXPANDED_NEGATIVE_STARTING_ROUND = 11;
export const EXPANDED_INCREMENT_STARTING_ROUND = 13;

export const INTRO_NEGATIVE_CHANCE = 0.12;
export const EXPANDED_NEGATIVE_CHANCE = 0.18;
export const INTRO_INCREMENT_WINDOW_MS = 18_000;
export const EXPANDED_INCREMENT_WINDOW_MS = 14_000;

export const INTRO_NEGATIVE_WEIGHTS = [
  { value: -1, weight: 14 },
  { value: -2, weight: 8 },
  { value: -3, weight: 3 }
] as const;

export const EXPANDED_NEGATIVE_WEIGHTS = [
  { value: -1, weight: 18 },
  { value: -2, weight: 12 },
  { value: -3, weight: 8 },
  { value: -4, weight: 5 },
  { value: -5, weight: 3 },
  { value: -6, weight: 2 },
  { value: -7, weight: 1 },
  { value: -8, weight: 1 },
  { value: -9, weight: 0.5 }
] as const;

export function isNegativeEnabled(progress: ProgressionSnapshot): boolean {
  return (
    progress.roundNumber >= NEGATIVE_ENABLED_STARTING_ROUND ||
    progress.score >= NEGATIVE_ENABLED_STARTING_SCORE
  );
}

export function isIncrementEnabled(progress: ProgressionSnapshot): boolean {
  return (
    progress.roundNumber >= INCREMENT_ENABLED_STARTING_ROUND ||
    progress.score >= INCREMENT_ENABLED_STARTING_SCORE
  );
}

export function isRefillEnabled(progress: ProgressionSnapshot): boolean {
  return (
    progress.roundNumber >= REFILL_ENABLED_STARTING_ROUND ||
    progress.score >= REFILL_ENABLED_STARTING_SCORE
  );
}

export function getNegativeDrawChance(progress: ProgressionSnapshot): number {
  if (progress.roundNumber >= EXPANDED_NEGATIVE_STARTING_ROUND) {
    return EXPANDED_NEGATIVE_CHANCE;
  }

  if (isNegativeEnabled(progress)) {
    return INTRO_NEGATIVE_CHANCE;
  }

  return 0;
}

export function getNegativeWeights(progress: ProgressionSnapshot) {
  return progress.roundNumber >= EXPANDED_NEGATIVE_STARTING_ROUND
    ? EXPANDED_NEGATIVE_WEIGHTS
    : INTRO_NEGATIVE_WEIGHTS;
}

export function getIncrementLaneCount(progress: ProgressionSnapshot): number {
  if (progress.roundNumber >= EXPANDED_INCREMENT_STARTING_ROUND) {
    return 2;
  }

  if (isIncrementEnabled(progress)) {
    return 1;
  }

  return 0;
}

export function getIncrementDurationMs(progress: ProgressionSnapshot): number {
  return progress.roundNumber >= EXPANDED_INCREMENT_STARTING_ROUND
    ? EXPANDED_INCREMENT_WINDOW_MS
    : INTRO_INCREMENT_WINDOW_MS;
}
